/* HIBA under-5 m guard (2026-10-24, test theme). Rule source: snippets/hiba-under5.liquid.
   Any cart line whose variant has a photo and < 5 m stock is removed from the cart:
   - right after any /cart/add (fetch or XHR) made by the theme -> the add reports an error (422)
   - on every page load (data from layout: window.HIBA_U5.cartLow)
   - before checkout (re-checked live via the Section Rendering API)
   Note: a raw POST to /cart/add.js made outside the browser theme cannot be stopped by a theme;
   the line is removed on the next storefront page view / checkout click. */
(function () {
  'use strict';
  if (window.__hibaU5Guard) return; window.__hibaU5Guard = 1;
  var U5 = window.HIBA_U5 || {};
  var MSG = U5.msg || 'This colour is no longer available online (less than 5 m in stock).';
  var REMOVED = U5.removed || 'It was removed from your cart.';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var _fetch = window.fetch.bind(window);
  function lowKeys() {
    return _fetch(root + '?sections=hiba-u5-cart', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) { var m = String(j['hiba-u5-cart'] || '').match(/<script[^>]*>([\s\S]*?)<\/script>/); return m ? JSON.parse(m[1] || '[]') : []; })
      .catch(function () { return []; });
  }
  function removeKeys(keys) {
    var updates = {}; keys.forEach(function (k) { updates[k] = 0; });
    if (!keys.length) return Promise.resolve(false);
    return _fetch(root + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) })
      .then(function () { document.documentElement.setAttribute('data-hiba-u5-removed', String(keys.length)); return true; });
  }
  function notice() {
    if (document.getElementById('hiba-u5-notice')) return;
    var d = document.createElement('div'); d.id = 'hiba-u5-notice'; d.setAttribute('role', 'alert');
    d.style.cssText = 'position:fixed;left:50%;bottom:20px;transform:translateX(-50%);z-index:99999;background:#222;color:#fff;padding:12px 18px;border-radius:6px;font-size:14px;max-width:90%;text-align:center';
    d.textContent = MSG + ' ' + REMOVED;
    document.body.appendChild(d); setTimeout(function () { d.remove(); }, 8000);
  }
  function enforce() { return lowKeys().then(function (k) { return removeKeys(k).then(function (r) { if (r) notice(); return r; }); }); }
  function isAdd(url) { return /\/cart\/add(\.js|\.json)?(\?|$)/.test(String(url || '').split('#')[0].replace(/^https?:\/\/[^/]+/, '')); }
  function errBody() { return JSON.stringify({ status: 422, message: 'Cart Error', description: MSG }); }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url);
    var p = _fetch(input, init);
    if (!isAdd(url)) return p;
    return p.then(function (res) {
      if (!res.ok) return res;
      return lowKeys().then(function (k) {
        if (!k.length) return res;
        return removeKeys(k).then(function () { return new Response(errBody(), { status: 422, headers: { 'Content-Type': 'application/json' } }); });
      });
    });
  };
  var XO = XMLHttpRequest.prototype.open, XS = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__hibaAdd = isAdd(u); return XO.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    if (this.__hibaAdd) this.addEventListener('load', function () { enforce(); });
    return XS.apply(this, arguments);
  };
  /* plain form posts to /cart/add (no JS): page reload lands on cart with cartLow -> cleaned below */
  function onLoad() {
    var low = (window.HIBA_U5 && window.HIBA_U5.cartLow) || [];
    if (low.length) removeKeys(low).then(function () { notice(); if (/\/cart\/?$/.test(location.pathname)) setTimeout(function () { location.reload(); }, 1500); });
  }
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[name="checkout"], a[href*="/checkout"], button[form][name="checkout"]');
    if (!t || t.__hibaOk) return;
    e.preventDefault(); e.stopPropagation();
    enforce().then(function (removed) {
      if (removed) { location.href = root + 'cart'; return; }
      t.__hibaOk = true; t.click();
    });
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onLoad); else onLoad();
})();
